module.exports = __webpack_public_path__ + "static/media/endorsement-added.790c1bf2.svg";